import React from 'react'
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { Card } from '@mui/material';

export default function ArgoCDDeployOperation(props) {
    const { operation } = props
    
    return (
        <Card>
            <Paper sx={{ p: 2, minHeight: 183 }}>
                <Typography variant="h1" mb={2}>K8s Deployment</Typography>
                <Typography mb={2}>Deploy {operation.parameters.version} to {operation.parameters.cluster_name} in {operation.parameters.region}</Typography>
                <Typography>Status: {operation.status}</Typography>
                <Typography>Started: {operation.start_date}</Typography>
                {operation.end_date && <Typography>Completed: {operation.end_date}</Typography>}
                <p>Result: {JSON.stringify(operation.result)}</p>
            </Paper>
        </Card>
    );
}